/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-console */
import { AnimatePresence, motion } from 'framer-motion';
import React, {
    useState, useRef, useEffect, useCallback,
} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Modal from 'react-modal';
import { CamelCase } from '../../redux/helper/CamelCase';
import { GenerateDate, GenerateDateandTime } from '../../redux/helper/DateConverter';
import { userService } from '../../service/user.service';
import ThreeDotsLoader from '../../Components/LoadingDots';
import ModalPopup from '../../Components/ModalHandler';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
function ListOffers({
    setisPaneOpen,
    userList,
    render,
    currentPage,
    setCurrentPage,
    totalPage,
    setrender,
    setEditDAte,
    EditDAte,
    seteditpaneopen,
    handleSort,
    setsort,
    sort,
    setsortType,
    filter,
    handleActivateOrDeactivate,
    OpenPopup,
    setOpenPopup,
    actvloader,
    setactvloader,
    isEditId,
    setisEditId,
    setExportClick,
    collapse,
    viewprevilegeassigned,
    updateprevilegeassigned,
    deactivateprevilegeassigned,
    activateprevilegeassigned,
}) {
    const [searchValue, setsearchValue] = useState('');
    const [loading, setloading] = useState(false);
    const [statusLoader, setstatusLoader] = useState('');
    const [selectedUser, setselectedUser] = useState([]);
    const ref = useRef();
    const navigate = useNavigate();

    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (!ref.current.contains(event.target)) {
    //             setTimeout(() => {
    //                 setisEditId('');
    //             }, 500);
    //         }
    //     };
    //     document.addEventListener('mousedown', handleClickOutside);
    // }, [ref]);
    const SerachUser = (val) => {
        if (searchValue === '') {
            return val;
        }
        if (val.email.toLowerCase().includes(searchValue.toLowerCase())) {
            return val;
        }
    };

    const handleViewPageRouting = (user) => {
        const paramsObj = { code: user.offer_code };
        const searchParams = new URLSearchParams(paramsObj);
        navigate(`/manage-offers/view?${searchParams.toString()}`, { state: user });
    };

    const handleEditPageRouting = (user) => {
        const paramsObj = { code: user.offer_code };
        const searchParams = new URLSearchParams(paramsObj);
        navigate(`/manage-offers/${user.offer_code.split('/').join('-')}/update?${searchParams.toString()}`);
    };
    const handleColorStatus = (status) => {
        let res = '';
        if (status === '1') {
            res = 'border-[#D7F8DC] bg-[#D7F8DC] px-1 w-[82px]';
        }
        if (status === '0' || status === '0') {
            res = 'border-[#808285] bg-[#808285] text-[#FFFFFF] px-1 w-[82px]';
        }
        if (status === '3') {
            res = 'border-[#FFF2DE] bg-[#FFF2DE] text-[#555259] px-1 w-[82px]';
        }
        if (status === '2') {
            res = 'border-[#F8E1E4] bg-[#F8E1E4] text-[#555259] px-1 w-[82px]';
        }
        return res;
    };

    const handleImage = (status) => {
        let res = '';
        if (status === '1') {
            res = 'Active-icon.svg';
        }
        if (status === '0') {
            res = 'inactive-1.svg';
        }
        if (status === '3') {
            res = 'draft.svg';
        }
        if (status === '2') {
            res = 'expired-1.svg';
        }
        return res;
    };

    const handleActionButtonStatus = () => {
        setisEditId('');
    };

    return (

        <>
            <tbody>
                <Modal
                    style={customStyles}
                    isOpen={OpenPopup !== ''}
                    ariaHideApp={false}
                    onRequestClose={() => setOpenPopup('')}
                    onClick={() => {
                        setOpenPopup('');
                        setactvloader(false);
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
                        <div
                            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                        >
                            <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pt-7 rounded-t-md">
                                <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                    {(selectedUser.offer_status === '3' ? 'Activate' : 'Deactivate')}
                                    {' '}
                                    {' '}
                                    Offer
                                </h5>

                                <button
                                    type="button"
                                    className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                                <p className="text-xs6 font-normal text-[#555259]">
                                    {`${selectedUser.offer_code}`}
                                    {' '}
                                    is currently
                                    {' '}
                                    {selectedUser.offer_status === '1' ? 'Active' : 'Draft'}
                                    . Are you sure you
                                    {' '}
                                    want to
                                    {' '}
                                    {selectedUser.offer_status === '1' ? 'Deactivate' : 'Activate'}
                                    ?
                                </p>
                            </div>

                            <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-6 rounded-b-md">
                                <button
                                    onClick={() => {
                                        setOpenPopup('');
                                        setactvloader(false);
                                    }}
                                    type="button"
                                    className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] py-3 px-14 rounded-lg"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-14 rounded-lg"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleActivateOrDeactivate(selectedUser.offer_status === '3' ? 'activate' : 'deactivate', selectedUser.offer_code)}
                                >
                                    {actvloader ? <ThreeDotsLoader /> : 'Yes'}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                {Object.keys(userList).length > 0 && userList.offers?.Items.filter((val) => SerachUser(val)).map((user, i) => (

                    <AnimatePresence>
                        <motion.tr
                            className="bg-[#FDFDFE] border-b border-[#DFEAF7] relative"
                            style={{ zIndex: `${50 - i}` }}
                            key={user.employee_code}
                            animate={{ opacity: 1, x: 0 }}
                            initial={{ opacity: 0, x: -10 }}
                            exit={{ opacity: 0, x: -10 }}
                            transition={{ duration: 0.15 }}
                        >
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.offer_code}
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 sticky left-0 bg-[#ffffffe6]">
                                {user.offer_value}
                            </td>
                            {/* <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {user.description}
                            </td> */}
                            <td className="text-sm font-normal text-[#090406]">
                                {CamelCase(user.offer_type)}
                            </td>
                            <td className="text-sm font-normal text-[#090406]">
                                {user?.industrial_pocket}
                            </td>
                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                {GenerateDate(user.start_date)}
                            </td>
                            <td className="text-sm font-normal text-[#090406]  text-center">
                                {GenerateDate(user.end_date)}
                            </td>
                            <td className="text-xs font-normal py-2.5 px-7 text-center">
                                <a
                                    href="#"
                                    className={`flex rounded-sm border-2 ${handleColorStatus(user.offer_status)} py-0.5 pr-1.5 w-fit`}
                                >
                                    {/* <img src={`images/${user.offer_status === '1' ? 'Active-icon.svg' : 'inactive-1.svg'}`} alt="icon" className="px-2" /> */}
                                    <img src={`images/${handleImage(user.offer_status)}`} alt="icon" className="px-2" />
                                    {user.offer_status === '0' ? 'Inactive' : user.offer_status === '1' ? 'Active' : user.offer_status === '2' ? 'Expired' : 'Draft'}
                                </a>
                            </td>
                            <td className={`py-2.5 px-7 sticky right-0 bg-[#ffffffe6] ${filter || OpenPopup ? '' : 'z-50'} `}>
                                <div
                                    className="dropdown relative flex justify-center cursor-pointer"
                                    onClick={() => {
                                        if (isEditId === i) {
                                            setisEditId('');
                                        } else {
                                            setisEditId(i);
                                        }
                                    }}
                                >
                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img
                                            src="images/more-vertical.svg"
                                            alt="icon"
                                        />
                                    </button>
                                    {isEditId !== '' && (

                                        <ul
                                            className={`dropdown-menu min-w-max absolute ${isEditId === i ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-[10px] shadow-s2 z-[${i + 50}]`}
                                            aria-labelledby="dropdownMenuButton1"
                                            style={{ right: collapse ? '117px' : '60px' }}
                                        >
                                            {viewprevilegeassigned
                                                && (
                                                    <li
                                                        className="px-5 pb-4 py-4 dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#resetpasswordModal"
                                                        ref={ref}
                                                    >
                                                        <button
                                                            onClick={() => { handleViewPageRouting(user); }}
                                                        >
                                                            View

                                                        </button>
                                                    </li>
                                                )}
                                            {updateprevilegeassigned && (user.offer_status !== '1' && user.offer_status !== '0' && user.offer_status !== '2')
                                                && (
                                                    <li className="px-5 py-1.5" ref={ref}>
                                                        <button onClick={() => handleEditPageRouting(user)} className="dropdown-item text-xs5 text-start font-normal text-[#555259] w-full inline-block">Edit</button>
                                                    </li>
                                                )}
                                            {((user.offer_status === '1' && deactivateprevilegeassigned) || (user.offer_status !== '1' && activateprevilegeassigned)) && (user.offer_status === '1' || user.offer_status === '3')
                                                && (
                                                    <li
                                                        className="px-5 pt-1.5 pb-5 cursor-pointer"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#deactivateUserModal"
                                                        onClick={() => {
                                                            setselectedUser(user);
                                                            setOpenPopup('active');
                                                            setisEditId('');
                                                        }}
                                                        ref={ref}
                                                    >
                                                        <a
                                                            className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block"
                                                        >
                                                            {user.offer_status === '1' ? 'Deactivate' : 'Activate'}

                                                        </a>
                                                    </li>
                                                )}

                                        </ul>
                                    )}
                                </div>
                            </td>
                        </motion.tr>
                        <tr className="h-1" />

                    </AnimatePresence>
                ))}
            </tbody>
            <div className={['filter-overlay ', (isEditId !== '') ? 'filter-open' : ''].join('')} onClick={() => handleActionButtonStatus()} />

        </>

    );
}

export default ListOffers;
